import type { Components, Theme } from '@mui/material';

export const textFieldCustomizations: Components<Theme> = {
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
      hiddenLabel: true,
    },
  },
};
